import React, { useState } from "react";
import api from "../../services/api";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Card, CardContent } from "../ui/card";
import { Search, UserPlus, User, Users } from "lucide-react";

const SearchCommunity = ({ handleJoinCommunity }) => {
  const [searchCommunity, setsearchCommunity] = useState("");
  const [searchResult, setsearchResult] = useState([]);

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!searchCommunity) return;

    api.post("/community/search", {
        community_name: searchCommunity,
      })
      .then((res) => res.data)
      .then((data) => {
        if (Array.isArray(data)) {
          setsearchResult(data);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  return (
    <div className="space-y-4">
      <form onSubmit={handleSearch} className="flex gap-2">
        <Input
          placeholder="Search communities..."
          value={searchCommunity}
          onChange={(e) => setsearchCommunity(e.target.value)}
          className="flex-1"
        />
        <Button type="submit" className="gap-2">
          <Search className="h-4 w-4" />
          Search
        </Button>
      </form>

      <div className="space-y-2">
        {searchResult.map((item) => (
          <Card key={item.community_id} className="hover:shadow-md transition-shadow">
            <CardContent className="p-4">
              <div className="flex items-center justify-between">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-2">
                    <Users className="h-5 w-5 text-primary" />
                    <h3 className="font-semibold">{item.community_name}</h3>
                  </div>
                  <p className="text-sm text-gray-600 mb-2">{item.description}</p>
                  <div className="flex items-center gap-4 text-sm text-gray-500">
                    <div className="flex items-center gap-1">
                      <User className="h-4 w-4" />
                      <span>{item.member_count || 0} members</span>
                    </div>
                    <div>
                      <span className="font-medium">Code:</span> {item.community_id}
                    </div>
                  </div>
                </div>
                <Button
                  onClick={() => handleJoinCommunity(item.community_id)}
                  className="gap-2"
                  size="sm"
                >
                  <UserPlus className="h-4 w-4" />
                  Join
                </Button>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default SearchCommunity;
